import { Typography } from "@mui/material";

import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";

import {
  VisualModelViewerOfGenericDamages,
  VisualModelViewerOfGenericDamagesProps,
} from "./VisualModelViewerOfGenericDamages";

export interface OwnProps {
  viewProps: VisualModelViewerOfGenericDamagesProps;
}
type Props = OwnProps & Omit<AppModalProps, "children">;

export function VisualModelViewerOfGenericDamagesModal({ viewProps, ...dialogProps }: Props) {
  const openStatus = useModalOpenStatus(dialogProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        <Typography component='div' variant='h1' sx={{ display: "flex", alignItems: "center" }}>
          Damages
        </Typography>
      </AppModalTitle>

      <AppModalContent>
        {openStatus.isOpen && <VisualModelViewerOfGenericDamages {...viewProps} />}
      </AppModalContent>
    </AppModal>
  );
}
